import React from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorks } from '../components/HowItWorks';
import { ValueProposition } from '../components/ValueProposition';
import { WaysToJoin } from '../components/WaysToJoin';
import { UseCases } from '../components/UseCases';
import { ProductDeepDive } from '../components/ProductDeepDive';
import { TrustSecurity } from '../components/TrustSecurity';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-522" data-mp="2dj1m8sn1nf7y">
      <SEO title="KittyPot | Group Money Made Simple" description="Create shared kitties, track expenses and settle up together. KittyPot shows who owes who and lets your group settle directly, in the app or from a browser invite link." ogTitle="KittyPot | Group Money Made Simple" ogDescription="Create shared kitties, track expenses, settle up together." path="/" jsonLd={{
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'KittyPot',
      url: 'https://www.kittypot.com',
      description: 'KittyPot is a shared expense tracker for friends, trips and housemates. Create a kitty, track who paid what, see who owes what, and settle up directly with each other. KittyPot does not hold or move money.'
    }} data-id="element-523" data-mp="3kxd1t5hk42zq" />
      <Navbar data-id="element-524" data-mp="287kpfe51f1sp" />
      <main data-id="element-525" data-mp="2895lj8702sso">
        <HeroSection data-id="element-526" data-mp="288ni9rlx7eb9" />
        <ProblemSection data-id="element-527" data-mp="2861d1ymi5aw7" />
        <HowItWorks data-id="element-528" data-mp="239aw792vib9q" />
        <ValueProposition data-id="element-529" data-mp="239sqw19w0hfj" />
        <WaysToJoin data-id="element-530" data-mp="23alzl7seph0b" />
        <UseCases data-id="element-531" data-mp="236y78byp70n6" />
        <ProductDeepDive data-id="element-532" data-mp="1z7fu42d4btuw" />
        <Pricing data-id="element-533" data-mp="1z7pdv87kl4s5" />
        <TrustSecurity data-id="element-534" data-mp="1z64ixhhcfjtr" />
        <FinalCTA data-id="element-535" data-mp="1z9ik4me9tmzm" />
      </main>
      <Footer data-id="element-536" data-mp="1u8l5gjsgzb2v" />
    </div>;
}